var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "26px",
    viewBox: "0 0 30 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GeneralSystems/Home/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Express-Interest-flow-V2-Final-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-EI---Overview",
    transform: "translate(-958.000000, -817.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(878.000000, 814.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems/Home/32",
    transform: "translate(80.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.3523398 C0.674688169,13.1310295 1.85775482,13.2208783 2.64394608,12.5526278 L3.74952753,11.6241901 L3.74952753,26 L13.1252362,26 L13.1252362,16.7156228 L16.8766536,16.7156228 L16.8766536,26 L26.2523624,26 L26.2523624,11.6092153 L27.3579438,12.5470122 C28.1441351,13.2152628 29.3272017,13.125414 30,12.3467243 L26.2523624,9.2862491 L26.2523624,3.71562275 L22.5009449,3.71562275 L22.5009449,6.12282217 L15,0 L0,12.3523398 Z M11.2504725,14.8568754 L11.2504725,24.1431246 L5.62618118,24.1431246 L5.62618118,10.0331174 L15,2.44650828 L24.3757087,10.0162707 L24.3757087,24.1431246 L18.7514174,24.1431246 L18.7514174,14.8568754 L11.2504725,14.8568754 Z",
    id: "Home"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.606bf349b082489e22f94b9725e87e3a.svg";
export { ForwardRef as ReactComponent };